var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconColourFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.652,
    x2: 350.309,
    y1: 131.892,
    y2: 455.559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.23,
    x2: 422.878,
    xlinkHref: "#lg1",
    y1: 324.154,
    y2: 324.154
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.251,
    x2: 269.251,
    xlinkHref: "#lg2",
    y1: 386.895,
    y2: 452.621
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.31,
    x2: 152.117,
    xlinkHref: "#lg2",
    y1: 187.051,
    y2: 145.714
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.273,
    x2: 432.115,
    y1: 90.515,
    y2: 191.357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.775,
    x2: 356.699,
    y1: 38.017,
    y2: 115.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.973,
    x2: 107.407,
    y1: 123.154,
    y2: 162.587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.057,
    x2: 257.728,
    y1: 31.951,
    y2: 115.622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.265,
    x2: 380.265,
    y1: 145.901,
    y2: 214.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.749,
    x2: 113.749,
    y1: 106.218,
    y2: 162.223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.49,
    x2: 455.814,
    xlinkHref: "#lg1",
    y1: 343.44,
    y2: 343.44
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.151,
    x2: 321.808,
    y1: 160.393,
    y2: 484.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffebb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.749,
    x2: 240.749,
    xlinkHref: "#lg2",
    y1: 440.22,
    y2: 543.179
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208.485 137.052c0-16.435-13.323-29.758-29.758-29.758h-99.218c-16.435 0-29.758 13.323-29.758 29.758v314.69c0 16.435 13.323 29.758 29.758 29.758h379.482c16.435 0 29.758-13.323 29.758-29.758v-255.175c0-16.435-13.323-29.758-29.758-29.758h-220.748c-16.435 0-29.758-13.323-29.758-29.757z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.992 166.809h-42.147v314.69h42.147c16.435 0 29.758-13.323 29.758-29.758v-255.174c-.001-16.435-13.324-29.758-29.758-29.758z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.752 362.115v89.627c0 16.435 13.323 29.758 29.758 29.758h379.482c16.435 0 29.758-13.323 29.758-29.758v-89.627z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m238.243 166.809c-16.403 0-29.706-13.271-29.757-29.661-.052-16.419-13.339-29.854-29.758-29.854h-59.096v33.647c0 39.724 32.202 71.926 71.926 71.926h59.525v-46.058z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.346 197.287c0-29.588-11.284-59.175-33.853-81.744l57.754-57.754c38.526 38.526 57.78 89.003 57.789 139.497z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.749 81.69v-81.69c50.495.009 100.971 19.263 139.497 57.789l-57.754 57.754c-22.567-22.568-52.155-33.853-81.743-33.853z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.463 197.287c.009-50.494 19.263-100.971 57.789-139.497l57.754 57.754c-22.568 22.568-33.853 52.156-33.853 81.744h-81.69z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.006 115.543-57.754-57.754c38.526-38.526 89.003-57.78 139.497-57.789v81.69c-29.587 0-59.175 11.285-81.743 33.853z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m438.036 197.287c-.005-27.928-5.909-55.846-17.693-81.744h-97.85c22.568 22.569 33.853 52.156 33.853 81.744z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.074 96.559c-18.4 30.942-27.605 65.829-27.611 100.728h81.69c0-29.588 11.284-59.175 33.853-81.744 7.628-7.628 16.07-13.934 25.031-18.984z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.797 205.382v276.117h6.195c16.435 0 29.758-13.323 29.758-29.758v-210.407z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.984 165.553c0-16.435-13.323-29.758-29.758-29.758h-99.218c-16.435 0-29.758 13.323-29.758 29.758v314.69c0 16.435 13.323 29.758 29.758 29.758h379.483c16.435 0 29.758-13.323 29.758-29.758v-255.175c0-16.435-13.323-29.758-29.758-29.758h-220.749c-16.435 0-29.758-13.323-29.758-29.757z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.251 390.616v89.627c0 16.435 13.323 29.758 29.758 29.758h379.482c16.435 0 29.758-13.323 29.758-29.758v-89.627z",
    fill: "url(#SVGID_13_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColourFile);
export default __webpack_public_path__ + "static/media/icon-colour-file.4ac6d2f351624d6dbb2a96cb4eeb2e73.svg";
export { ForwardRef as ReactComponent };